<template>
  <CustomSelect
    class="w-100"
    inputId="discountTypePicker"
    inputLabel="نوع تخفیف"
    :customOptions="discountTypes"
    :value="value"
    @input="$emit('input', $event)"
  >
  </CustomSelect>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      discountTypes: [
        {
          value: 1,
          text: "مبلغ",
        },
        {
          value: 2,
          text: "درصد",
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
